import { Checkbox, Textarea, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { ThumbDislike24Filled, ThumbLike24Filled } from '@fluentui/react-icons';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IFeedback } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { CDialog } from './CDialog';

export interface DialogFeedbackAnswerProps {
    open: boolean;
    feedback?: IFeedback;
    onFeedback: (feedback?: IFeedback) => void;
}
const useStyle = makeStyles({
    form: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.flex(1, 1, 'auto'),
        ...shorthands.padding('0.5rem', '0rem'),
    },
});

// shows a dialog to collect feedback
export const DialogFeedbackAnswer: FC<DialogFeedbackAnswerProps> = (props: DialogFeedbackAnswerProps) => {
    const { open, feedback, onFeedback } = props;
    const [comment, setComment] = useState<string>('');
    const [isHarmful, setIsHarmful] = useState<boolean >(false);
    const [isNotTrue, setIsNotTrue] = useState<boolean >(false);
    const [isNotHelpful, setIsNotHelpful] = useState<boolean >(false);
    const { t } = useTranslation();
    const classes = useStyle();

    useEffect(() => {
        setComment (feedback?.comment || '');
        setIsHarmful(feedback?.isHarmfullUnsafe || false);
        setIsNotHelpful(feedback?.isNotHelpful|| false);
        setIsNotTrue(feedback?.isNotTrue|| false);
    }, [feedback])

    return (
        <CDialog
            open={open}
            icon={() => (feedback?.positive ? <ThumbLike24Filled color={tokens.colorPaletteGreenBackground2} /> : <ThumbDislike24Filled color={tokens.colorPaletteRedBackground3} />)}
            title={t('feedback.title')}
            primaryActionText={t('feedback.button.text')}
            secondaryActionText={t('feedback.button.cancel')}
            onSecondaryAction={() => onFeedback(undefined)}
            onPrimaryAction={() => {
                onFeedback({ positive: feedback?.positive!, isHarmfullUnsafe: isHarmful, isNotTrue: isNotTrue, isNotHelpful: isNotHelpful, comment: comment });
            }}
        >
            <div className={classes.form}>
                <Textarea placeholder={t('feedback.placeholder')} value={comment} onChange={(_, data) => setComment(data.value)} />
                {feedback?.positive === false ? (
                    <>
                        <Checkbox checked={isHarmful} label={t('feedback.harmful')} onChange={(_, data) => setIsHarmful(data.checked == true ? true : false)} />
                        <Checkbox checked={isNotTrue} label={t('feedback.notTrue')} onChange={(_, data) => setIsNotTrue(data.checked == true ? true : false)} />
                        <Checkbox checked={isNotHelpful} label={t('feedback.notHelpful')} onChange={(_, data) => setIsNotHelpful(data.checked == true ? true : false)} />
                    </>
                ) : null}
            </div>
        </CDialog>
    );
};
